export const CREATE_PACKAGE = 'CREATE_PACKAGE'
export const UPDATE_PACKAGE = 'UPDATE_PACKAGE'
export const DELETE_PACKAGE = 'DELETE_PACKAGE'